import { Button, styled } from '@engyalo/design-system';
import { ButtonProps, css, Icon, Typography } from '@mui/material';

export const CTActionButtonWrapper = styled(Button)<ButtonProps>(
  ({ theme }) => css`
    background-color: ${theme.palette.common.white};
    border-top: 0.1rem solid ${theme.palette.neutral.var20};
    padding: 1.2rem 6rem;
    display: flex;
    gap: 0.8rem;
    justify-content: center;
    align-items: center;
    align-self: stretch;
    box-shadow: none;
    cursor: pointer;
    height: 4rem;
    width: 100%;
    min-width: 26rem;
    border-radius: 0;
    &:hover,
    :active {
      background-color: ${theme.palette.neutral.var10};
      box-shadow: none;
    }
    &:last-of-type {
      border-radius: 0 0 0.6rem 0.6rem;
    }
  `
);

export const CustomTypography = styled(Typography)(
  ({ theme }) => css`
    color: ${theme.palette.primary.dark};
    text-align: center;
    text-transform: capitalize;
  `
);

export const CustomIcon = styled(Icon)(
  ({ theme }) => css`
    color: ${theme.palette.primary.dark};
    font-size: 1.2rem;
  `
);
